export default __webpack_public_path__ + "static/media/partner-program-image-1.0f0b3316.png";